import {session} from '../Utilities/Session.svelte';

export function doFetch(url, params, query) {
    const defaults = {
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'include',
        headers: {
            "Content-Type": 'application/json'
        }
    }

    if (!params) {
        params = {}
    }

    for (let key of Object.keys(defaults)) {
        if (!params.hasOwnProperty(key)) {
            params[key] = defaults[key]
        }
    }

    if (query) {
        url += '?' + qs.stringify(query, { indices: false });
    }

    return new Promise((resolve, reject) => {
        fetch(url, params).then((response) => {
            if (response.ok) {
                return resolve(response);
            }

            if (response.status == 401) {
                session.set({
                    loggedIn: false,
                    user: ""
                });
            }

            return reject(response);

        }).catch((error) => {
            console.error(error);
        });
    });
}